import React from 'react';
import classes from './ContainerWhite.module.css';

interface ContainerWhiteProps extends React.HTMLAttributes<HTMLDivElement> {
  children: React.ReactNode;
  /** Intensidad de la sombra */
  shadow?: 'xs' | 'sm' | 'md' | 'lg';
}

/**
 * Contenedor con fondo blanco, padding, border radius y sombra.
 * Ideal para formularios, tablas, contenido principal, etc.
 */
export const ContainerWhite = React.forwardRef<HTMLDivElement, ContainerWhiteProps>(({
  children,
  shadow = 'sm',
  className,
  ...props
}, ref) => {
  const containerClasses = [
    classes.containerFixed,
    classes[`shadow-${shadow}`],
    className
  ].filter(Boolean).join(' ');

  return (
    <div
      ref={ref}
      className={containerClasses}
      {...props}
    >
      {children}
    </div>
  );
});

ContainerWhite.displayName = 'ContainerWhite';